import Vue from 'vue'
const Bus = new Vue({})
Bus.ACTION_SHOW_ALERT = "show_alert"
Bus.ACTION_LOG_OUT = "log_out"
export default Bus



// WEBPACK FOOTER //
// ./src/components/bus.js